module.exports = __webpack_public_path__ + "img/slack.cd7d23d8.svg";